import { Grid } from '@material-ui/core'
import React from 'react'
import UnderConstruction from '../components/elements/UnderConstruction'

function InformationsInscriptionsScreen() {
  return (
    <Grid container>
      <UnderConstruction />
    </Grid>
  )
}

export default InformationsInscriptionsScreen
